import type { SupportTicketStatus } from './types';

export interface SupportTicketState {
  status: SupportTicketStatus;
}

const OPEN_FOR_REPLY: ReadonlySet<SupportTicketStatus> = new Set([
  'open',
  'awaiting_church',
  'awaiting_platform',
  'escalated',
  'resolved',
]);

export const canChurchReply = (row: SupportTicketState): boolean => OPEN_FOR_REPLY.has(row.status);

export const canChurchClose = (row: SupportTicketState): boolean =>
  row.status !== 'closed' && row.status !== 'resolved';
